<template>
    <aside class="blaze-sidebar">
      <!-- Логотип и кнопка "Create New" -->
      <div class="sidebar-header">
        <img 
          class="logo-img" 
          src="https://via.placeholder.com/90x40?text=BLAZE" 
          alt="Blaze Logo" 
        />
        <button class="btn-create-new">
          <i class="fas fa-plus-circle"></i>
          Create New
        </button>
      </div>
  
      <!-- Основные ссылки навигации -->
      <nav class="nav-menu">
        <ul>
          <li>
            <a href="#" class="active">
              <i class="fas fa-house-user"></i>
              Home
            </a>
          </li>
          <li>
            <a href="#">
              <i class="fas fa-gem"></i>
              Brand Kit
            </a>
          </li>
          <li>
            <a href="#">
              <i class="fas fa-th-large"></i>
              Templates
            </a>
          </li>
          <li>
            <a href="#">
              <i class="fas fa-calendar-week"></i>
              Calendar
            </a>
          </li>
          <li>
            <a href="#">
              <i class="fas fa-chart-line"></i>
              Analytics
            </a>
          </li>
          <li>
            <a href="#">
              <i class="fas fa-check-square"></i>
              Approvals
            </a>
          </li>
        </ul>
      </nav>
  
      <!-- Заголовок и список файлов/проектов -->
      <div class="projects-section">
        <h3>Files &amp; Projects</h3>
        <ul>
          <li>
            <a href="#">
              <i class="fas fa-history"></i>
              Recent
            </a>
          </li>
          <li>
            <a href="#">
              <i class="fas fa-cloud-upload-alt"></i>
              Uploads
            </a>
          </li>
          <li>
            <a href="#">
              <i class="fas fa-calendar-day"></i>
              Content Calendar
            </a>
          </li>
          <li>
            <a href="#">
              <i class="fas fa-folder-open"></i>
              test
            </a>
          </li>
        </ul>
      </div>
  
      <!-- Ссылки в самом низу -->
      <div class="footer-links">
        <ul>
          <li>
            <a href="#">
              <i class="fas fa-gift"></i>
              Refer &amp; Earn
            </a>
          </li>
          <li>
            <a href="#">
              <i class="fas fa-user-friends"></i>
              Invite Team Members
            </a>
          </li>
          <li>
            <a href="#">
              <i class="fas fa-plug"></i>
              Integrations
            </a>
          </li>
          <li>
            <a href="#">
              <i class="fas fa-question"></i>
              Help &amp; Learn Blaze
            </a>
          </li>
        </ul>
      </div>
    </aside>
  </template>
  
  <script>
  export default {
    name: 'BlazeSidebar',
  };
  </script>
  
  <style scoped>
  /* Можно подключить Font Awesome или другой набор иконок: */
  /* @import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css'); */
  
  .blaze-sidebar {
    width: 240px;
    min-height: 100vh;
    background-color: #d2f0f2;
    padding: 1.5rem;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    font-family: 'Inter', sans-serif;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
  }
  
  .blaze-sidebar:hover {
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  }
  
  .sidebar-header {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 2rem;
  }
  
  .logo-img {
    width: 90px;
    height: auto;
    margin-bottom: 1rem;
    transition: transform 0.3s ease;
  }
  
  .logo-img:hover {
    transform: scale(1.1);
  }
  
  .btn-create-new {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.6rem 1rem;
    background-color: #fff;
    color: #333;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    cursor: pointer;
    font-weight: 600;
    font-size: 0.8rem;
    transition: background-color 0.2s ease, transform 0.2s ease;
  }
  
  .btn-create-new:hover {
    background-color: #f2f2f2;
    transform: translateY(-2px);
  }
  
  .nav-menu ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  
  .nav-menu ul li {
    margin-bottom: 0.5rem;
  }
  
  .nav-menu ul li a {
    display: flex;
    align-items: center;
    padding: 0.5rem 0.75rem;
    color: #222;
    text-decoration: none;
    border-radius: 6px;
    transition: background-color 0.2s ease, transform 0.2s ease;
    font-size: 0.85rem;
  }
  
  .nav-menu ul li a:hover {
    background-color: rgba(0, 0, 0, 0.07);
    transform: translateX(5px);
  }
  
  .nav-menu ul li a.active {
    background-color: rgba(0, 0, 0, 0.15);
  }
  
  .nav-menu ul li a i {
    width: 20px;
    margin-right: 0.75rem;
    text-align: center;
    font-size: 0.9rem;
  }
  
  .projects-section {
    margin-top: 1.5rem;
  }
  
  .projects-section h3 {
    font-size: 0.75rem;
    text-transform: uppercase;
    color: #666;
    margin-bottom: 0.5rem;
    padding-left: 0.75rem;
  }
  
  .projects-section ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  
  .projects-section ul li {
    margin-bottom: 0.5rem;
  }
  
  .projects-section ul li a {
    display: flex;
    align-items: center;
    color: #222;
    text-decoration: none;
    padding: 0.5rem 0.75rem;
    border-radius: 6px;
    transition: background-color 0.2s ease, transform 0.2s ease;
    font-size: 0.85rem;
  }
  
  .projects-section ul li a:hover {
    background-color: rgba(0, 0, 0, 0.07);
    transform: translateX(5px);
  }
  
  .projects-section ul li a i {
    width: 20px;
    margin-right: 0.75rem;
    text-align: center;
    font-size: 0.9rem;
  }
  
  .footer-links {
    margin-top: auto;
    padding-top: 1.5rem;
  }
  
  .footer-links ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  
  .footer-links ul li {
    margin-bottom: 0.5rem;
  }
  
  .footer-links ul li a {
    display: flex;
    align-items: center;
    color: #222;
    text-decoration: none;
    padding: 0.5rem 0.75rem;
    border-radius: 6px;
    transition: background-color 0.2s ease, transform 0.2s ease;
    font-size: 0.85rem;
  }
  
  .footer-links ul li a:hover {
    background-color: rgba(0, 0, 0, 0.07);
    transform: translateX(5px);
  }
  
  .footer-links ul li a i {
    width: 20px;
    margin-right: 0.75rem;
    text-align: center;
    font-size: 0.9rem;
  }
  </style>
